import { render, staticRenderFns } from "./DirectMessagePopupModal.vue?vue&type=template&id=588019ba&scoped=true&"
import script from "./DirectMessagePopupModal.vue?vue&type=script&lang=js&"
export * from "./DirectMessagePopupModal.vue?vue&type=script&lang=js&"
import style0 from "./DirectMessagePopupModal.vue?vue&type=style&index=0&id=588019ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588019ba",
  null
  
)

export default component.exports